import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }
  public async authenticat(): Promise<boolean> {
    let flag;
    await this.http.get('/api/Auth/check').toPromise().then(res => {
       flag = res;
    });
    return flag;
  }
  public async checkEducation(): Promise<boolean> {
    let flag;
    await this.http.get('/api/Education/CheckEducation').toPromise().then(res => {
       flag = res;
    });
    return flag;
  }
}
